import type { MailMessage } from "../shared/utils/types";

export function useMail() {
  const sending = ref(false);
  const error = ref<string | null>(null);
  const { t, locale } = useI18n();

  async function send(message: MailMessage): Promise<boolean> {
    sending.value = true;
    error.value = null;

    try {
      await $fetch("/api/mail", {
        method: "POST",
        body: {
          data: message,
          locale: locale.value
        },
      });
      return true;
    } catch (err) {
      error.value = t("requestPartner.form.error");
      return false;
    } finally {
      sending.value = false;
    }
  }

  return { send, sending, error };
}
